import React from 'react';
//import './signature.css';

import { withStyles } from '@material-ui/core/styles';

import { neosperience } from './style';

const redHerringUrl =
        'http://www.redherring.com/red-herring-europe/2010-red-herring-top-100-europe-winners/',
    coolVendorUrl = 'http://www.gartner.com/technology/research/cool-vendors/',
    becomeAFan = 'https://www.facebook.com/Neosperience';

class Signature extends React.Component {
    render() {
        //const { classes } = this.props;
        return (
            <div className="neosperience">
                <span className="user">Neosperience</span>
                <span className="pipe"> | </span>
                <span className="user">Empathy In Technology</span>
                <br />
                <span className="signature">Neosperience Spa</span>
                <br />
                <span className="signature">
                    Via Gaspare Gozzi 1/a, 20129 Milano (Italy)
                </span>
                <span className="pipe"> | </span>
                <span className="info">
                    <strong>t</strong>
                    <a className="links" href="tel:+390236755690">
                        +390236755690
                    </a>
                    <span className="pipe"> | </span>
                    <strong>t</strong>
                    <a className="links" href="tel:+390236755706">
                        +390236755706
                    </a>
                    <span className="pipe"> | </span>
                    <strong>f</strong>
                    <a className="links" href="+390236755956">
                        +390236755956
                    </a>
                    <span className="pipe"> | </span>
                </span>
                <div className="smallText">
                    <a className="links" href={redHerringUrl}>
                        Red Herring Top 2013 Europe Winner
                    </a>
                    <br />
                    <a className="links" href={coolVendorUrl}>
                        Gartner Cool Vendor 2013
                    </a>
                    <br />
                    <a className="links" href={becomeAFan}>
                        Become a Neosperience fan
                    </a>
                    <p>
                        Information in this email including any attachments may
                        be privileged, confidential and is intended exclusively
                        for the addressee. The views expressed may not be
                        official policy, but the personal views of the
                        originator. If you have received it in error, please
                        notify the sender by return email and delete it from
                        your system. You should not reproduce, distribute,
                        store, retransmit, use or disclose its contents to
                        anyone
                    </p>
                </div>
            </div>
        );
    }
}

export default withStyles(neosperience)(Signature);



// WEBPACK FOOTER //
// ./src/NeosperienceSignature.js